module.exports = __webpack_public_path__ + "img/bruce-mars.0c440467.jpg";